import {
    ShopOutlined,
    UserOutlined,
    DashboardOutlined,
    CodeOutlined,
    DatabaseOutlined,
    SolutionOutlined,
    AppstoreOutlined,
    BarChartOutlined,
    TeamOutlined,
    ShoppingCartOutlined,
    CheckCircleOutlined,
    LaptopOutlined,
    FileSearchOutlined,
} from '@ant-design/icons';
import React from 'react';

export const sapoPosDetail = {
    title: 'POS - Hệ thống quản lý bán hàng tại quầy',
    description: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Tổng quan</h2>
            <p className="mb-4">
                Hệ thống quản lý bán hàng tại quầy là một hệ thống quản lý bán hàng toàn diện, được thiết kế đặc biệt để
                đáp ứng nhu cầu của các cửa hàng bán lẻ hiện đại. Dự án này được phát triển bởi nhóm chúng tôi gồm 4
                thành viên trong khoảng thời gian thực tập tại Sapo.{' '}
                Trong dự án này, tôi đảm nhận vai trò Full-stack Developer, chịu trách nhiệm phát triển cả frontend và
                backend cho nhiều tính năng chính của hệ thống.
            </p>

            <p className="mb-4">
                Hệ thống quản lý bán hàng tại quầy không chỉ đơn thuần là một công cụ bán hàng tại quầy mà còn là một
                nền tảng quản lý tập trung, giúp các doanh nghiệp vừa và nhỏ tối ưu hóa quy trình bán hàng, quản lý hàng
                tồn kho một cách hiệu quả, theo dõi và chăm sóc khách hàng chuyên nghiệp, cùng với các công cụ báo cáo
                phân tích kinh doanh chuyên sâu, hỗ trợ chủ doanh nghiệp đưa ra các quyết định kinh doanh sáng suốt.
            </p>
            <p className="mb-4">
                Hệ thống được xây dựng với kiến trúc hiện đại, sử dụng ReactJS và Material UI cho phần frontend cùng
                Spring Boot cho phần backend. Điều này mang lại trải nghiệm người dùng mượt mà, hiệu năng cao và khả
                năng mở rộng trong tương lai. Bên cạnh đó, hệ thống cũng được thiết kế với tính bảo mật cao, đảm bảo
                thông tin kinh doanh và dữ liệu khách hàng luôn được bảo vệ.
            </p>

            <div className="mb-6">
                <img
                    src="/assets/images/projects/sapo-pos/intro.jpg"
                    alt="Sapo POS - Hệ thống quản lý bán hàng tại quầy"
                    className="w-full rounded-lg shadow-md"
                />
                <p className="text-sm text-gray-600 italic mt-2 text-center">
                    Giao diện tổng quan của hệ thống quản lý bán hàng tại quầy
                </p>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">Các tính năng chính của hệ thống</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h4 className="font-semibold text-blue-700 mb-2">Bán hàng tại quầy</h4>
                    <p className="text-sm text-gray-700">
                        Giao diện bán hàng hiện đại, dễ sử dụng, hỗ trợ tìm kiếm nhanh sản phẩm, áp dụng khuyến mãi, và
                        xử lý thanh toán đa dạng.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-semibold text-green-700 mb-2">Quản lý khách hàng</h4>
                    <p className="text-sm text-gray-700">
                        Theo dõi thông tin khách hàng, lịch sử mua hàng, quản lý điểm thưởng và chương trình khách hàng
                        thân thiết, ghi nhận phản hồi.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h4 className="font-semibold text-purple-700 mb-2">Quản lý sản phẩm</h4>
                    <p className="text-sm text-gray-700">
                        Danh mục sản phẩm, biến thể, giá bán, giá vốn, quản lý hình ảnh sản phẩm, mã vạch, và thuộc tính
                        tùy chỉnh.
                    </p>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500">
                    <h4 className="font-semibold text-amber-700 mb-2">Quản lý đơn hàng</h4>
                    <p className="text-sm text-gray-700">
                        Xử lý đơn hàng, theo dõi trạng thái, lịch sử thanh toán, in hóa đơn, xử lý đơn trả hàng và hoàn
                        tiền.
                    </p>
                </div>

                <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                    <h4 className="font-semibold text-red-700 mb-2">Thống kê và báo cáo</h4>
                    <p className="text-sm text-gray-700">
                        Báo cáo doanh thu, lợi nhuận, số lượng bán, sản phẩm bán chạy, phân tích hành vi khách hàng, và
                        xu hướng bán hàng.
                    </p>
                </div>

                <div className="bg-cyan-50 p-4 rounded-lg border-l-4 border-cyan-500">
                    <h4 className="font-semibold text-cyan-700 mb-2">Quản lý nhân sự và cửa hàng</h4>
                    <p className="text-sm text-gray-700">
                        Phân quyền nhân viên, theo dõi ca làm việc, quản lý thông tin cửa hàng, và cấu hình hệ thống.
                    </p>
                </div>
            </div>
        </>
    ),
    problem: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Vấn đề cần giải quyết</h2>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-md mb-6">
                <p className="italic text-gray-700">
                    "Trong bối cảnh thương mại bán lẻ đang chuyển mình mạnh mẽ, các doanh nghiệp vừa và nhỏ (SMEs) đang
                    đối mặt với áp lực phải nâng cao hiệu quả vận hành và cải thiện trải nghiệm khách hàng để cạnh tranh
                    với các đối thủ lớn. Tuy nhiên, nhiều doanh nghiệp vẫn đang bị kìm hãm bởi hệ thống quản lý thủ công
                    lạc hậu và thiếu các công cụ công nghệ phù hợp."
                </p>
            </div>

            <p className="mb-6 text-gray-800">
                Qua quá trình nghiên cứu chúng tôi đã xác định năm thách thức chính mà các cửa hàng bán lẻ vừa và nhỏ
                thường gặp phải:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border-t-4 border-red-500">
                    <div className="p-5">
                        <div className="flex items-center mb-3">
                            <div className="w-10 h-10 flex-shrink-0 bg-red-100 rounded-full flex items-center justify-center mr-3">
                                <span className="text-red-600 font-bold">1</span>
                            </div>
                            <h3 className="font-bold text-lg text-gray-800">Quản lý thủ công kém hiệu quả</h3>
                        </div>
                        <p className="text-gray-700 mb-3">
                            Nhiều cửa hàng vẫn đang sử dụng phương pháp quản lý thủ công như sổ sách giấy hoặc bảng tính
                            Excel đơn giản, dẫn đến tốn thời gian, dễ sai sót và khó theo dõi.
                        </p>
                        <div className="bg-red-50 p-3 rounded-md">
                            <p className="text-sm text-red-700">
                                <span className="font-semibold">Hệ quả:</span> Thời gian xử lý đơn hàng kéo dài, sai sót
                                trong tính toán, khó kiểm soát hàng tồn kho và dễ xảy ra thất thoát.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border-t-4 border-yellow-500">
                    <div className="p-5">
                        <div className="flex items-center mb-3">
                            <div className="w-10 h-10 flex-shrink-0 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                                <span className="text-yellow-600 font-bold">2</span>
                            </div>
                            <h3 className="font-bold text-lg text-gray-800">Dữ liệu phân tán và thiếu kết nối</h3>
                        </div>
                        <p className="text-gray-700 mb-3">
                            Thông tin về sản phẩm, khách hàng, đơn hàng và kho hàng thường được lưu trữ rời rạc ở nhiều
                            nguồn khác nhau, gây khó khăn trong việc truy xuất và tổng hợp.
                        </p>
                        <div className="bg-yellow-50 p-3 rounded-md">
                            <p className="text-sm text-yellow-700">
                                <span className="font-semibold">Hệ quả:</span> Quyết định kinh doanh không kịp thời, bỏ
                                lỡ cơ hội bán hàng, và trải nghiệm khách hàng kém do thiếu thông tin liên kết.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border-t-4 border-green-500">
                    <div className="p-5">
                        <div className="flex items-center mb-3">
                            <div className="w-10 h-10 flex-shrink-0 bg-green-100 rounded-full flex items-center justify-center mr-3">
                                <span className="text-green-600 font-bold">3</span>
                            </div>
                            <h3 className="font-bold text-lg text-gray-800">Thiếu công cụ hỗ trợ bán hàng hiện đại</h3>
                        </div>
                        <p className="text-gray-700 mb-3">
                            Các cửa hàng nhỏ thường thiếu các công cụ bán hàng hiện đại như máy quét mã vạch, hệ thống
                            thanh toán tích hợp, và khả năng áp dụng khuyến mãi một cách linh hoạt.
                        </p>
                        <div className="bg-green-50 p-3 rounded-md">
                            <p className="text-sm text-green-700">
                                <span className="font-semibold">Hệ quả:</span> Quy trình bán hàng chậm, trải nghiệm
                                khách hàng kém, và mất đi nhiều cơ hội tăng doanh thu thông qua các chương trình khuyến
                                mãi phù hợp.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border-t-4 border-blue-500">
                    <div className="p-5">
                        <div className="flex items-center mb-3">
                            <div className="w-10 h-10 flex-shrink-0 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                                <span className="text-blue-600 font-bold">4</span>
                            </div>
                            <h3 className="font-bold text-lg text-gray-800">Hạn chế trong phân tích kinh doanh</h3>
                        </div>
                        <p className="text-gray-700 mb-3">
                            Thiếu công cụ phân tích dữ liệu bán hàng, hành vi khách hàng, và hiệu quả kinh doanh khiến
                            doanh nghiệp khó đưa ra quyết định dựa trên dữ liệu.
                        </p>
                        <div className="bg-blue-50 p-3 rounded-md">
                            <p className="text-sm text-blue-700">
                                <span className="font-semibold">Hệ quả:</span> Chiến lược kinh doanh thiếu hiệu quả, khó
                                nhận biết xu hướng thị trường, và không tận dụng được thế mạnh cũng như khắc phục điểm
                                yếu.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border-t-4 border-purple-500 mb-8">
                <div className="p-5">
                    <div className="flex items-center mb-3">
                        <div className="w-10 h-10 flex-shrink-0 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                            <span className="text-purple-600 font-bold">5</span>
                        </div>
                        <h3 className="font-bold text-lg text-gray-800">
                            Quản lý nhân sự và thông tin cửa hàng phân tán
                        </h3>
                    </div>
                    <p className="text-gray-700 mb-3">
                        Việc quản lý nhân viên, phân quyền, và theo dõi hiệu suất làm việc còn hạn chế, đặc biệt đối với
                        các cửa hàng có nhiều chi nhánh hoặc nhiều nhân viên bán hàng.
                    </p>
                    <div className="bg-purple-50 p-3 rounded-md">
                        <p className="text-sm text-purple-700">
                            <span className="font-semibold">Hệ quả:</span> Khó kiểm soát hoạt động của nhân viên, rủi ro
                            về bảo mật thông tin, và thiếu sự đồng bộ trong vận hành giữa các chi nhánh.
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-indigo-500 mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    Giá trị mà một hệ thống Quản lý bán hàng tại quầy hiện đại mang lại
                </h3>
                <p className="text-gray-700 mb-3">
                    Những thách thức trên là cơ hội để phát triển một hệ thống POS toàn diện, có thể giúp các cửa hàng
                    bán lẻ:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                    <li>Tối ưu hóa và tự động hóa quy trình bán hàng, giảm thiểu sai sót và tiết kiệm thời gian</li>
                    <li>
                        Tập trung dữ liệu vào một hệ thống duy nhất, tạo ra cái nhìn tổng thể về hoạt động kinh doanh
                    </li>
                    <li>Nâng cao trải nghiệm khách hàng thông qua quy trình thanh toán nhanh chóng và chuyên nghiệp</li>
                    <li>Cung cấp công cụ phân tích sâu để đưa ra quyết định kinh doanh thông minh</li>
                    <li>Quản lý nhân sự hiệu quả và đảm bảo tính bảo mật trong vận hành cửa hàng</li>
                </ul>
            </div>

            <p className="text-gray-800 font-medium">
                Nhận thức rõ những thách thức và cơ hội này, chúng tôi đã phát triển dự án Quản lý bán hàng tại quầy -
                POS toàn diện, nhằm giải quyết các vấn đề trên và mang lại giá trị thực cho các doanh nghiệp bán lẻ vừa
                và nhỏ.
            </p>
        </>
    ),
    solution: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Giải pháp đề xuất</h2>

            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-5 rounded-lg mb-8 border-l-4 border-blue-500">
                <p className="text-gray-800 mb-3">
                    <span className="font-semibold">Dự án Quản lý bán hàng tại quầy</span> là một giải pháp toàn diện
                    được thiết kế đặc biệt cho các doanh nghiệp bán lẻ vừa và nhỏ, nhằm số hóa và tự động hóa toàn bộ
                    quy trình bán hàng. Hệ thống không chỉ giải quyết các vấn đề hiện tại mà còn tạo nền tảng vững chắc
                    cho sự phát triển trong tương lai thông qua 6 trụ cột chính:
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* Giao diện bán hàng chuyên nghiệp */}
                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 py-4 px-6">
                        <div className="flex items-center">
                            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white text-purple-600 font-bold text-lg mr-3">
                                1
                            </span>
                            <h3 className="text-xl font-bold text-white">Giao diện bán hàng chuyên nghiệp</h3>
                        </div>
                    </div>
                    <div className="p-6">
                        <p className="text-gray-700 mb-4">
                            Dự án cung cấp giao diện bán hàng hiện đại, trực quan và dễ sử dụng, giúp nhân viên thực
                            hiện các giao dịch nhanh chóng và chính xác:
                        </p>
                        <ul className="space-y-3">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-1">
                                    <span className="w-2 h-2 bg-purple-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold block text-gray-800">
                                        Đa dạng phương thức tìm kiếm sản phẩm
                                    </span>
                                    <p className="text-sm text-gray-600">
                                        Tìm kiếm bằng tên, mã, hoặc duyệt qua danh mục
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-1">
                                    <span className="w-2 h-2 bg-purple-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold block text-gray-800">
                                        Xử lý thanh toán linh hoạt
                                    </span>
                                    <p className="text-sm text-gray-600">
                                        Hỗ trợ nhiều phương thức thanh toán và xử lý đồng thời nhiều đơn hàng
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-5 h-5 rounded-full bg-purple-100 flex items-center justify-center mr-3 mt-1">
                                    <span className="w-2 h-2 bg-purple-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold block text-gray-800">
                                        Áp dụng khuyến mãi thông minh
                                    </span>
                                    <p className="text-sm text-gray-600">
                                        Tự động áp dụng chương trình giảm giá và tính toán điểm thưởng
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Tích hợp quản lý tập trung */}
                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-600 to-cyan-600 py-4 px-6">
                        <div className="flex items-center">
                            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white text-blue-600 font-bold text-lg mr-3">
                                2
                            </span>
                            <h3 className="text-xl font-bold text-white">Quản lý tập trung toàn diện</h3>
                        </div>
                    </div>
                    <div className="p-6">
                        <p className="text-gray-700 mb-4">
                            Hệ thống tích hợp tất cả các khía cạnh của hoạt động bán lẻ vào một nền tảng duy nhất, loại
                            bỏ sự phân tán dữ liệu:
                        </p>

                        <div className="grid grid-cols-1 gap-4 mb-4">
                            <div className="p-3 bg-blue-50 rounded-lg">
                                <h4 className="font-semibold text-blue-800 mb-1">Quản lý hàng hóa và kho bãi</h4>
                                <p className="text-sm text-gray-700">
                                    Theo dõi tồn kho theo thời gian thực, cảnh báo hết hàng, và tạo lập kế hoạch nhập
                                    hàng tự động
                                </p>
                            </div>

                            <div className="p-3 bg-blue-50 rounded-lg">
                                <h4 className="font-semibold text-blue-800 mb-1">Quản lý khách hàng</h4>
                                <p className="text-sm text-gray-700">
                                    Lưu trữ thông tin khách hàng, lịch sử mua hàng, và các chương trình khách hàng thân
                                    thiết
                                </p>
                            </div>

                            <div className="p-3 bg-blue-50 rounded-lg">
                                <h4 className="font-semibold text-blue-800 mb-1">Quản lý đơn hàng và giao dịch</h4>
                                <p className="text-sm text-gray-700">
                                    Theo dõi toàn bộ vòng đời đơn hàng, từ tạo mới đến hoàn thành và xử lý trả hàng
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {/* Phân tích dữ liệu kinh doanh */}
                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-600 to-teal-600 py-3 px-4">
                        <div className="flex items-center">
                            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white text-green-600 font-bold text-base mr-2">
                                3
                            </span>
                            <h3 className="text-lg font-bold text-white">Phân tích dữ liệu kinh doanh</h3>
                        </div>
                    </div>
                    <div className="p-4">
                        <p className="text-gray-700 mb-3 text-sm">
                            Trang bị công cụ phân tích dữ liệu mạnh mẽ giúp đưa ra quyết định kinh doanh thông minh:
                        </p>

                        <ul className="space-y-2 mb-3">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        Báo cáo doanh thu đa chiều
                                    </span>
                                    <p className="text-xs text-gray-600">
                                        Phân tích theo sản phẩm, thời gian, nhân viên
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        Phân tích hành vi khách hàng
                                    </span>
                                    <p className="text-xs text-gray-600">Nhận diện mẫu mua hàng và sở thích</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-green-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">Biểu đồ trực quan</span>
                                    <p className="text-xs text-gray-600">Hiển thị dữ liệu dưới dạng đồ thị dễ hiểu</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Quản lý nhân sự hiệu quả */}
                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-amber-600 to-orange-600 py-3 px-4">
                        <div className="flex items-center">
                            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white text-amber-600 font-bold text-base mr-2">
                                4
                            </span>
                            <h3 className="text-lg font-bold text-white">Quản lý nhân sự hiệu quả</h3>
                        </div>
                    </div>
                    <div className="p-4">
                        <p className="text-gray-700 mb-3 text-sm">
                            Hệ thống phân quyền và quản lý nhân viên toàn diện, đảm bảo an toàn và hiệu quả:
                        </p>

                        <ul className="space-y-2 mb-3">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-amber-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-amber-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        Phân quyền chi tiết
                                    </span>
                                    <p className="text-xs text-gray-600">Kiểm soát quyền truy cập theo vai trò</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-amber-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-amber-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        Theo dõi hoạt động
                                    </span>
                                    <p className="text-xs text-gray-600">Ghi nhận lịch sử đăng nhập và thao tác</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-amber-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-amber-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        Đánh giá hiệu suất
                                    </span>
                                    <p className="text-xs text-gray-600">Thống kê doanh số theo nhân viên</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Xử lý đa kênh và tích hợp */}
                <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-red-600 to-pink-600 py-3 px-4">
                        <div className="flex items-center">
                            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white text-red-600 font-bold text-base mr-2">
                                5
                            </span>
                            <h3 className="text-lg font-bold text-white">Tích hợp đa kênh</h3>
                        </div>
                    </div>
                    <div className="p-4">
                        <p className="text-gray-700 mb-3 text-sm">
                            Kết nối và đồng bộ hóa các kênh bán hàng khác nhau để tạo trải nghiệm thống nhất:
                        </p>

                        <ul className="space-y-2 mb-3">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-red-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">Xuất/nhập dữ liệu</span>
                                    <p className="text-xs text-gray-600">Hỗ trợ nhiều định dạng phổ biến</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-red-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">
                                        In hóa đơn và báo cáo
                                    </span>
                                    <p className="text-xs text-gray-600">Tùy chỉnh mẫu in theo nhu cầu</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 w-4 h-4 rounded-full bg-red-100 flex items-center justify-center mr-2 mt-1">
                                    <span className="w-1.5 h-1.5 bg-red-600 rounded-full"></span>
                                </span>
                                <div>
                                    <span className="font-semibold text-sm block text-gray-800">Khả năng mở rộng</span>
                                    <p className="text-xs text-gray-600">Kiến trúc cho phép thêm tính năng mới</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Giải pháp kiến trúc kỹ thuật */}
            <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 mb-8">
                <div className="bg-gradient-to-r from-indigo-600 to-violet-600 py-4 px-6">
                    <div className="flex items-center">
                        <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white text-indigo-600 font-bold text-lg mr-3">
                            6
                        </span>
                        <h3 className="text-xl font-bold text-white">Kiến trúc kỹ thuật hiện đại</h3>
                    </div>
                </div>
                <div className="p-6">
                    <p className="text-gray-700 mb-4">
                        Dự án được xây dựng trên nền tảng công nghệ hiện đại, đảm bảo hiệu suất, bảo mật và khả năng mở
                        rộng:
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div className="p-3 bg-indigo-50 rounded-lg">
                            <h4 className="font-semibold text-indigo-800 mb-1">Kiến trúc RESTful API</h4>
                            <p className="text-sm text-gray-700">
                                Phân tách rõ ràng giữa frontend và backend, cho phép tích hợp với các hệ thống khác
                                trong tương lai
                            </p>
                        </div>

                        <div className="p-3 bg-indigo-50 rounded-lg">
                            <h4 className="font-semibold text-indigo-800 mb-1">Bảo mật đa lớp</h4>
                            <p className="text-sm text-gray-700">
                                JWT Authentication, mã hóa dữ liệu, và cơ chế phòng chống tấn công web phổ biến
                            </p>
                        </div>

                        <div className="p-3 bg-indigo-50 rounded-lg">
                            <h4 className="font-semibold text-indigo-800 mb-1">Tối ưu hiệu suất</h4>
                            <p className="text-sm text-gray-700">
                                Caching thông minh, lazy loading, và tối ưu hóa truy vấn cơ sở dữ liệu
                            </p>
                        </div>

                        <div className="p-3 bg-indigo-50 rounded-lg">
                            <h4 className="font-semibold text-indigo-800 mb-1">Giao diện responsive</h4>
                            <p className="text-sm text-gray-700">
                                Hoạt động mượt mà trên nhiều thiết bị, từ máy tính đến tablet
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Đặc điểm nổi bật */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg shadow-inner mb-6 border-l-4 border-blue-500">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Đặc điểm nổi bật của giải pháp</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-white p-4 rounded-lg shadow-sm">
                        <div className="flex items-center mb-3">
                            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-blue-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                            </div>
                            <span className="font-semibold text-gray-800">Dễ sử dụng</span>
                        </div>
                        <p className="text-sm text-gray-600">
                            Giao diện trực quan, thân thiện với người dùng, giảm thiểu thời gian đào tạo nhân viên mới.
                        </p>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow-sm">
                        <div className="flex items-center mb-3">
                            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-green-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                    />
                                </svg>
                            </div>
                            <span className="font-semibold text-gray-800">Toàn diện</span>
                        </div>
                        <p className="text-sm text-gray-600">
                            Tích hợp nhiều khía cạnh của hoạt động bán lẻ trong một nền tảng duy nhất.
                        </p>
                    </div>

                    <div className="bg-white p-4 rounded-lg shadow-sm">
                        <div className="flex items-center mb-3">
                            <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4 text-red-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                    />
                                </svg>
                            </div>
                            <span className="font-semibold text-gray-800">Bảo mật</span>
                        </div>
                        <p className="text-sm text-gray-600">
                            Bảo vệ dữ liệu kinh doanh và thông tin khách hàng với các biện pháp bảo mật hiện đại.
                        </p>
                    </div>
                </div>
            </div>
        </>
    ),
    features: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Tính năng chính</h2>

            <div className="space-y-8">
                {/* Đăng nhập & Phân quyền */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <UserOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Đăng nhập & Phân quyền</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Xác thực người dùng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Hệ thống đăng nhập an toàn với JWT, bảo vệ tài khoản bằng các biện pháp như giới
                                        hạn số lần đăng nhập sai, các phiên đăng nhập có thời hạn, và ghi lại lịch sử
                                        đăng nhập.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Phân quyền chi tiết</h4>
                                    <p className="text-gray-700 mb-2">
                                        Quản lý quyền truy cập theo vai trò (Role-based Access Control), cho phép phân
                                        quyền chi tiết đến từng chức năng cụ thể như xem, thêm, sửa, xóa đối với các đối
                                        tượng như sản phẩm, đơn hàng, khách hàng và báo cáo.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Quản lý tài khoản</h4>
                                    <p className="text-gray-700 mb-2">
                                        Cho phép người dùng cập nhật thông tin cá nhân, đổi mật khẩu, và thiết lập các
                                        tùy chọn giao diện. Quản trị viên có thể tạo, chỉnh sửa, và vô hiệu hóa tài
                                        khoản.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 border-t border-gray-200 pt-4">
                        <img
                            src="/assets/images/projects/sapo-pos/dang-nhap.jpg"
                            alt="Giao diện đăng nhập Sapo POS"
                            className="rounded-lg shadow-md"
                        />
                        <p className="text-sm text-center text-gray-600 mt-2 italic">
                            Giao diện đăng nhập với xác thực JWT bảo mật
                        </p>
                    </div>
                </div>

                {/* Giao diện bán hàng tại quầy */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <ShoppingCartOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Giao diện bán hàng tại quầy</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-green-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Thiết kế tối ưu cho bán hàng nhanh</h4>
                                    <p className="text-gray-700 mb-2">
                                        Giao diện trực quan, được tối ưu hóa cho màn hình cảm ứng, với các thao tác đơn
                                        giản giúp nhân viên xử lý đơn hàng nhanh chóng. Tìm kiếm sản phẩm linh hoạt bằng
                                        tên, mã hoặc duyệt qua danh mục.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-green-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Quản lý giỏ hàng linh hoạt</h4>
                                    <p className="text-gray-700 mb-2">
                                        Dễ dàng thêm, bớt, điều chỉnh số lượng sản phẩm trong giỏ hàng. Hỗ trợ áp dụng
                                        giảm giá trực tiếp trên từng sản phẩm hoặc toàn bộ đơn hàng, tự động tính thuế
                                        và hiển thị thông tin chi tiết.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-green-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Thanh toán đa dạng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Hỗ trợ nhiều hình thức thanh toán như tiền mặt, thẻ, chuyển khoản, và kết hợp
                                        nhiều phương thức trong cùng một đơn hàng. In hóa đơn trực tiếp cho khách hàng.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 border-t border-gray-200 pt-4">
                            <img
                                src="/assets/images/projects/sapo-pos/ban-hang-tai-quay.jpg"
                                alt="Giao diện bán hàng tại quầy"
                                className="rounded-lg shadow-md"
                            />
                            <p className="text-sm text-center text-gray-600 mt-2 italic">
                                Giao diện bán hàng tại quầy với đầy đủ tính năng
                            </p>
                        </div>
                    </div>
                </div>

                {/* Quản lý đơn hàng */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <FileSearchOutlined className="text-amber-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Quản lý đơn hàng</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-amber-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Theo dõi trạng thái đơn hàng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Quản lý toàn bộ vòng đời đơn hàng với nhiều trạng thái như Mới tạo, Đã thanh
                                        toán, Đang xử lý, Hoàn thành, Đã hủy. Hệ thống thông báo khi có thay đổi trạng
                                        thái quan trọng.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-amber-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Tìm kiếm và lọc nâng cao</h4>
                                    <p className="text-gray-700 mb-2">
                                        Tìm kiếm đơn hàng theo nhiều tiêu chí như mã đơn, khách hàng, nhân viên bán
                                        hàng, phương thức thanh toán, ngày tạo, và trạng thái. Lọc theo khoảng thời gian
                                        giúp dễ dàng xem lại lịch sử đơn hàng.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-amber-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Xử lý đơn trả hàng và hoàn tiền</h4>
                                    <p className="text-gray-700 mb-2">
                                        Tạo đơn trả hàng dựa trên đơn hàng gốc với khả năng trả một phần hoặc toàn bộ
                                        sản phẩm. Tự động cập nhật kho hàng và xử lý hoàn tiền theo phương thức thanh
                                        toán ban đầu.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 pt-4">
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/danh-sach-don-hang.jpg"
                                    alt="Danh sách đơn hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Quản lý danh sách đơn hàng với nhiều tùy chọn lọc
                                </p>
                            </div>
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/chi-tiet-don-hang.jpg"
                                    alt="Chi tiết đơn hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Xem chi tiết thông tin đơn hàng
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quản lý khách hàng */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-violet-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <UserOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Quản lý khách hàng</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-purple-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Hồ sơ khách hàng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Lưu trữ thông tin chi tiết về khách hàng như thông tin liên hệ, địa chỉ, ngày
                                        sinh, thông tin thanh toán và ghi chú khách hàng. Dễ dàng cập nhật và duy trì
                                        thông tin luôn mới nhất.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-purple-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Lịch sử mua hàng và tương tác</h4>
                                    <p className="text-gray-700 mb-2">
                                        Theo dõi lịch sử mua hàng của từng khách hàng, bao gồm các đơn hàng đã mua, giá
                                        trị mua, sản phẩm ưa thích và phương thức thanh toán thường dùng. Ghi lại các
                                        tương tác và phản hồi của khách hàng.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-purple-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Chương trình khách hàng thân thiết</h4>
                                    <p className="text-gray-700 mb-2">
                                        Quản lý điểm thưởng khách hàng, xếp hạng khách hàng theo doanh số, và áp dụng
                                        các ưu đãi đặc biệt cho khách hàng thân thiết. Cài đặt thông báo về số điểm, các
                                        ưu đãi sắp hết hạn.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 pt-4">
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/danh-sach-khach-hang.jpg"
                                    alt="Danh sách khách hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Quản lý danh sách khách hàng
                                </p>
                            </div>
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/chi-tiet-khach-hang.jpg"
                                    alt="Chi tiết khách hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Xem chi tiết thông tin và lịch sử khách hàng
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quản lý sản phẩm */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-cyan-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <AppstoreOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Quản lý sản phẩm</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Catalog sản phẩm toàn diện</h4>
                                    <p className="text-gray-700 mb-2">
                                        Quản lý thông tin chi tiết về sản phẩm bao gồm tên, mã, mô tả, hình ảnh, giá
                                        bán, giá vốn, thuộc tính, và các biến thể (màu sắc, kích thước). Hỗ trợ phân
                                        loại sản phẩm theo danh mục.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Quản lý hình ảnh sản phẩm</h4>
                                    <p className="text-gray-700 mb-2">
                                        Tải lên và quản lý nhiều hình ảnh cho mỗi sản phẩm. Tự động tối ưu hóa hình ảnh
                                        và tạo thumbnail với tích hợp Cloudinary, đảm bảo hiển thị nhanh và tiết kiệm
                                        dung lượng.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-blue-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Quản lý mã sản phẩm</h4>
                                    <p className="text-gray-700 mb-2">
                                        Hỗ trợ nhập hoặc tự động tạo mã cho sản phẩm. Quét mã nhanh chóng khi bán hàng.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 pt-4">
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/danh-sach-san-pham.jpg"
                                    alt="Danh sách sản phẩm"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Quản lý danh sách sản phẩm
                                </p>
                            </div>
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/chi-tiet-san-pham.jpg"
                                    alt="Chi tiết sản phẩm"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Xem và chỉnh sửa chi tiết sản phẩm
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Thống kê và báo cáo */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-red-500 to-rose-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <BarChartOutlined className="text-red-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Thống kê và báo cáo</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-red-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Báo cáo doanh thu và lợi nhuận</h4>
                                    <p className="text-gray-700 mb-2">
                                        Theo dõi doanh thu theo ngày, tuần, tháng, quý và năm. Phân tích lợi nhuận gộp
                                        và biên lợi nhuận theo sản phẩm, danh mục hoặc nhân viên bán hàng. So sánh hiệu
                                        suất giữa các khoảng thời gian.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-red-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Phân tích sản phẩm và xu hướng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Xác định sản phẩm bán chạy, sản phẩm tồn kho lâu, sản phẩm sinh lời cao. Phân
                                        tích xu hướng mua hàng theo mùa hoặc thời điểm trong ngày để tối ưu hóa kho hàng
                                        và chiến lược bán hàng.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-red-600 font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Xuất báo cáo đa định dạng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Hỗ trợ xuất báo cáo dưới dạng PDF hoặc in trực tiếp. Tùy chỉnh báo cáo với logo
                                        và thông tin cửa hàng.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 pt-4">
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/thong-ke-ban-hang.jpg"
                                    alt="Thống kê bán hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Thống kê doanh số bán hàng theo thời gian
                                </p>
                            </div>
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/in-bao-cao-doanh-thu.jpg"
                                    alt="In báo cáo doanh thu"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Xuất và in báo cáo doanh thu
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quản lý nhân sự và cửa hàng */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-indigo-500 to-purple-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <TeamOutlined className="text-indigo-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Quản lý nhân sự và cửa hàng</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-indigo-600 font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Quản lý thông tin nhân viên</h4>
                                    <p className="text-gray-700 mb-2">
                                        Lưu trữ hồ sơ nhân viên bao gồm thông tin cá nhân, vai trò, và quyền truy cập.
                                        Theo dõi doanh số bán hàng của nhân viên và tính lương hoa hồng theo doanh số
                                        hoặc lợi nhuận.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center mr-4">
                                    <span className="text-indigo-600 font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Thiết lập thông tin cửa hàng</h4>
                                    <p className="text-gray-700 mb-2">
                                        Quản lý thông tin cửa hàng như tên, logo, địa chỉ, thông tin liên hệ, giờ mở
                                        cửa. Thông tin này được sử dụng trên hóa đơn, báo cáo và các tài liệu khác.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 pt-4">
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/quan-ly-nhan-vien.jpg"
                                    alt="Quản lý nhân viên"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Quản lý thông tin và quyền hạn nhân viên
                                </p>
                            </div>
                            <div>
                                <img
                                    src="/assets/images/projects/sapo-pos/thong-tin-cua-hang.jpg"
                                    alt="Thông tin cửa hàng"
                                    className="rounded-lg shadow-md"
                                />
                                <p className="text-sm text-center text-gray-600 mt-2 italic">
                                    Quản lý thông tin và cấu hình cửa hàng
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    technologies: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Công nghệ sử dụng</h2>

            <div className="space-y-8">
                {/* Frontend */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <LaptopOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Frontend</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/react-2.svg" alt="ReactJS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">ReactJS</span>
                                <span className="text-xs text-gray-500 mt-1">Thư viện UI</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/redux.svg" alt="Redux Toolkit" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Redux Toolkit</span>
                                <span className="text-xs text-gray-500 mt-1">Quản lý state</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/material-ui.png" alt="Material UI" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Material UI</span>
                                <span className="text-xs text-gray-500 mt-1">UI Components</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/sass.png" alt="SCSS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">SCSS</span>
                                <span className="text-xs text-gray-500 mt-1">CSS Preprocessor</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/javascript.png" alt="JavaScript" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">JavaScript</span>
                                <span className="text-xs text-gray-500 mt-1">Ngôn ngữ</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Backend */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Backend</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            <div className="bg-green-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/spring-boot.png" alt="Spring Boot" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Spring Boot</span>
                                <span className="text-xs text-gray-500 mt-1">Framework</span>
                            </div>

                            <div className="bg-green-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img
                                        src="/assets/logos/spring-security.png"
                                        alt="Spring Security"
                                        className="w-8 h-8"
                                    />
                                </div>
                                <span className="font-medium text-gray-800">Spring Security</span>
                                <span className="text-xs text-gray-500 mt-1">Authentication</span>
                            </div>

                            <div className="bg-green-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/jwt.png" alt="JWT" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">JWT</span>
                                <span className="text-xs text-gray-500 mt-1">Token Auth</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Database & Storage */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-yellow-500 to-amber-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <DatabaseOutlined className="text-yellow-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Database & Storage</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div className="bg-yellow-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/mysql.png" alt="MySQL" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">MySQL</span>
                                <span className="text-xs text-gray-500 mt-1">Relational Database</span>
                                <div className="mt-2 text-xs text-gray-600">
                                    <span className="inline-block bg-yellow-100 rounded-full px-2 py-1">
                                        Dữ liệu chính
                                    </span>
                                </div>
                            </div>

                            <div className="bg-yellow-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/cloudinary.png" alt="Cloudinary" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Cloudinary</span>
                                <span className="text-xs text-gray-500 mt-1">Cloud Storage</span>
                                <div className="mt-2 text-xs text-gray-600">
                                    <span className="inline-block bg-yellow-100 rounded-full px-2 py-1">Hình ảnh</span>
                                    <span className="inline-block bg-yellow-100 rounded-full px-2 py-1 ml-1">
                                        Tối ưu hóa
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Development Tools */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <DashboardOutlined className="text-blue-700 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Development Tools</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                            <div className="bg-indigo-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/git.png" alt="Git" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Git</span>
                                <span className="text-xs text-gray-500 mt-1">Version Control</span>
                            </div>

                            <div className="bg-indigo-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/intellij.png" alt="IntelliJ IDEA" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">IntelliJ IDEA</span>
                                <span className="text-xs text-gray-500 mt-1">IDE</span>
                            </div>

                            <div className="bg-indigo-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vscode.jpeg" alt="VS Code" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">VS Code</span>
                                <span className="text-xs text-gray-500 mt-1">Code Editor</span>
                            </div>

                            <div className="bg-indigo-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/postman.svg" alt="Postman" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Postman</span>
                                <span className="text-xs text-gray-500 mt-1">API Testing</span>
                            </div>

                            <div className="bg-indigo-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/drawio.png" alt="DrawIo" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">DrawIo</span>
                                <span className="text-xs text-gray-500 mt-1">UML Design</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Architecture */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-gray-700 to-gray-900 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <SolutionOutlined className="text-gray-800 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Kiến trúc hệ thống</h3>
                    </div>

                    <div className="p-6">
                        <div className="flex flex-col items-center text-center">
                            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-8 rounded-full text-lg font-semibold mb-6">
                                RESTful API Architecture
                            </div>

                            <div className="mb-6 max-w-md text-gray-700">
                                <p>
                                    Dự án được xây dựng theo kiến trúc dịch vụ REST (Representational State
                                    Transfer), với sự phân tách rõ ràng giữa frontend và backend. Kiến trúc này cho phép
                                    giao tiếp linh hoạt giữa các thành phần, dễ dàng mở rộng và bảo trì.
                                </p>
                            </div>

                            <div className="flex flex-wrap justify-center gap-4">
                                <div className="bg-blue-50 rounded-lg py-2 px-4 text-blue-800 font-medium flex items-center">
                                    <CheckCircleOutlined className="mr-2" /> Tách biệt frontend & backend
                                </div>
                                <div className="bg-green-50 rounded-lg py-2 px-4 text-green-800 font-medium flex items-center">
                                    <CheckCircleOutlined className="mr-2" /> Stateless API
                                </div>
                                <div className="bg-purple-50 rounded-lg py-2 px-4 text-purple-800 font-medium flex items-center">
                                    <CheckCircleOutlined className="mr-2" /> JWT Authentication
                                </div>
                                <div className="bg-yellow-50 rounded-lg py-2 px-4 text-yellow-800 font-medium flex items-center">
                                    <CheckCircleOutlined className="mr-2" /> Responsive Design
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    architecture: 'RESTful API',
    screenshots: [
        {
            url: '/assets/images/projects/sapo-pos/intro.jpg',
            caption: 'Tổng quan về hệ thống Sapo POS',
        },
        {
            url: '/assets/images/projects/sapo-pos/dang-nhap.jpg',
            caption: 'Giao diện đăng nhập hệ thống',
        },
        {
            url: '/assets/images/projects/sapo-pos/ban-hang-tai-quay.jpg',
            caption: 'Giao diện bán hàng tại quầy',
        },
        {
            url: '/assets/images/projects/sapo-pos/danh-sach-don-hang.jpg',
            caption: 'Quản lý danh sách đơn hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/chi-tiet-don-hang.jpg',
            caption: 'Chi tiết đơn hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/tao-don-tra-hang.jpg',
            caption: 'Tạo đơn trả hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/danh-sach-khach-hang.jpg',
            caption: 'Quản lý danh sách khách hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/chi-tiet-khach-hang.jpg',
            caption: 'Chi tiết thông tin khách hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/them-moi-phan-hoi-khach-hang.jpg',
            caption: 'Thêm mới phản hồi khách hàng',
        },
        {
            url: '/assets/images/projects/sapo-pos/danh-sach-san-pham.jpg',
            caption: 'Quản lý danh sách sản phẩm',
        },
        {
            url: '/assets/images/projects/sapo-pos/chi-tiet-san-pham.jpg',
            caption: 'Chi tiết sản phẩm',
        },
        {
            url: '/assets/images/projects/sapo-pos/thong-ke-ban-hang.jpg',
            caption: 'Thống kê bán hàng theo thời gian',
        },
        {
            url: '/assets/images/projects/sapo-pos/in-bao-cao-doanh-thu.jpg',
            caption: 'In báo cáo doanh thu',
        },
        {
            url: '/assets/images/projects/sapo-pos/quan-ly-nhan-vien.jpg',
            caption: 'Quản lý nhân viên',
        },
        {
            url: '/assets/images/projects/sapo-pos/thong-tin-cua-hang.jpg',
            caption: 'Thông tin cửa hàng',
        },
    ],
    results: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết quả đạt được</h2>
            <p className="mb-4">Dự án này đã đạt được nhiều kết quả đáng kể:</p>

            <div className="mb-6 space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h3 className="text-lg font-semibold text-blue-700 mb-2">Hoàn thành đúng tiến độ</h3>
                    <p className="text-gray-700">
                        Dự án được hoàn thành trong vòng 1 tháng theo đúng kế hoạch ban đầu, với đầy đủ các tính năng đã
                        đề ra mà không cần gia hạn thời gian. Các cột mốc quan trọng đều được đáp ứng theo lộ trình phát
                        triển.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h3 className="text-lg font-semibold text-green-700 mb-2">Đáp ứng đầy đủ yêu cầu nghiệp vụ</h3>
                    <p className="text-gray-700">
                        Hệ thống đã triển khai thành công tất cả các tính năng nghiệp vụ cốt lõi của một hệ thống POS
                        hiện đại, từ quản lý bán hàng, quản lý khách hàng, quản lý sản phẩm và kho hàng đến báo cáo phân
                        tích kinh doanh.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h3 className="text-lg font-semibold text-purple-700 mb-2">Giao diện thân thiện, dễ sử dụng</h3>
                    <p className="text-gray-700">
                        Người dùng đánh giá cao về trải nghiệm sử dụng với giao diện trực quan, thân thiện và dễ tiếp
                        cận. Thời gian đào tạo nhân viên mới giảm đáng kể nhờ thiết kế UI/UX tối ưu và luồng công việc
                        hợp lý.
                    </p>
                </div>

                <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500">
                    <h3 className="text-lg font-semibold text-yellow-700 mb-2">Hoạt động ổn định và bảo mật</h3>
                    <p className="text-gray-700">
                        Hệ thống hoạt động ổn định trong các tình huống tải nặng, với tốc độ phản hồi nhanh và thời gian
                        ngừng hoạt động tối thiểu. Các biện pháp bảo mật được triển khai đảm bảo an toàn cho dữ liệu
                        khách hàng và thông tin kinh doanh.
                    </p>
                </div>

                <div className="bg-indigo-50 p-4 rounded-lg border-l-4 border-indigo-500">
                    <h3 className="text-lg font-semibold text-indigo-700 mb-2">Nâng cao hiệu quả kinh doanh</h3>
                    <p className="text-gray-700">
                        Qua đánh giá ban đầu, hệ thống giúp giảm thời gian xử lý đơn hàng trung bình, cải thiện độ chính
                        xác trong quản lý kho và tăng hiệu quả trong việc theo dõi và chăm sóc khách hàng.
                    </p>
                </div>
            </div>

            <div className="bg-white p-5 rounded-lg shadow-md mb-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">Phản hồi từ người dùng</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-gray-50 p-3 rounded-lg border-l-3 border-blue-400">
                        <p className="text-gray-700 italic">
                            "Giao diện bán hàng rất dễ sử dụng, nhân viên mới chỉ cần đào tạo trong vòng 30 phút là có
                            thể bắt đầu phục vụ khách hàng. Rất hài lòng với tốc độ của hệ thống."
                        </p>
                        <p className="text-right text-sm text-gray-600 mt-2">- Quản lý cửa hàng</p>
                    </div>

                    <div className="bg-gray-50 p-3 rounded-lg border-l-3 border-green-400">
                        <p className="text-gray-700 italic">
                            "Các báo cáo thống kê giúp tôi có cái nhìn tổng quan về tình hình kinh doanh và đưa ra quyết
                            định kịp thời. Việc quản lý kho hàng cũng trở nên dễ dàng hơn rất nhiều."
                        </p>
                        <p className="text-right text-sm text-gray-600 mt-2">- Chủ doanh nghiệp</p>
                    </div>
                </div>

                <div className="flex justify-center">
                    <div className="bg-gray-50 p-3 rounded-lg border-l-3 border-purple-400 max-w-lg">
                        <p className="text-gray-700 italic">
                            "Chức năng quản lý khách hàng giúp chúng tôi duy trì mối quan hệ tốt hơn với khách hàng cũ
                            và tăng tỷ lệ quay lại mua hàng. Hệ thống điểm thưởng và ưu đãi hoạt động rất hiệu quả."
                        </p>
                        <p className="text-right text-sm text-gray-600 mt-2">- Nhân viên marketing</p>
                    </div>
                </div>
            </div>

            <p className="mb-4">
                Nhìn chung, dự án đã thành công trong việc cung cấp một giải pháp toàn diện cho các cửa hàng bán lẻ,
                giúp số hóa và tối ưu hóa quy trình kinh doanh, từ đó nâng cao hiệu quả vận hành và trải nghiệm khách
                hàng.
            </p>
        </>
    ),
    challenges: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Thách thức</h2>
            <p className="mb-4">Trong quá trình phát triển, đội dự án đã gặp và vượt qua một số thách thức đáng kể:</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg shadow-sm border-l-4 border-blue-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-blue-800">Tích hợp các thư viện và công nghệ</h3>
                    <p className="text-gray-700">
                        Việc kết hợp các công nghệ khác nhau như ReactJS, Material UI, Spring Boot và MySQL đòi hỏi khả
                        năng tích hợp và xử lý sự tương thích giữa các phiên bản. Đặc biệt, tích hợp Material UI với hệ
                        thống state management của Redux Toolkit đã gặp một số vấn đề về re-rendering và performance.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg shadow-sm border-l-4 border-purple-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-purple-800">Xử lý logic nghiệp vụ phức tạp</h3>
                    <p className="text-gray-700">
                        Các quy trình nghiệp vụ phức tạp như tính giá, áp dụng khuyến mãi, xử lý đơn hàng trả/hoàn và
                        đồng bộ tồn kho yêu cầu thiết kế logic chặt chẽ. Việc đảm bảo tính nhất quán dữ liệu trong các
                        tình huống đặc biệt (như đơn hàng bị hủy giữa chừng) là một thách thức lớn.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-green-50 to-teal-50 p-4 rounded-lg shadow-sm border-l-4 border-green-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-green-800">Xử lý bất đồng bộ</h3>
                    <p className="text-gray-700">
                        Quản lý các hoạt động bất đồng bộ trong ReactJS, đặc biệt khi phải xử lý nhiều API call liên
                        tiếp hoặc phụ thuộc lẫn nhau, đòi hỏi cách tiếp cận cẩn thận.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-yellow-50 to-amber-50 p-4 rounded-lg shadow-sm border-l-4 border-yellow-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-yellow-800">Tối ưu hóa hiệu suất</h3>
                    <p className="text-gray-700">
                        Tối ưu hóa hiệu suất ứng dụng, đặc biệt với các danh sách dữ liệu lớn và biểu đồ thống kê phức
                        tạp, đòi hỏi nhiều kỹ thuật như virtualization, memoization, và debouncing. Tối ưu hóa truy vấn
                        database với nhiều điều kiện lọc và sắp xếp cũng là một thách thức.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-red-50 to-rose-50 p-4 rounded-lg shadow-sm border-l-4 border-red-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-red-800">Đảm bảo bảo mật</h3>
                    <p className="text-gray-700">
                        Triển khai hệ thống bảo mật toàn diện với JWT, xác thực Role-based Access Control, và bảo vệ
                        chống lại các cuộc tấn công phổ biến như XSS, CSRF và SQL Injection là một nhiệm vụ phức tạp.
                        Việc quản lý token, refresh token và xử lý hết hạn phiên cũng đòi hỏi sự cẩn trọng.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-cyan-50 to-sky-50 p-4 rounded-lg shadow-sm border-l-4 border-cyan-500 hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-semibold mb-2 text-cyan-800">Thiết kế cơ sở dữ liệu phù hợp</h3>
                    <p className="text-gray-700">
                        Việc thiết kế cơ sở dữ liệu vừa phải đảm bảo tính toàn vẹn dữ liệu, vừa cho phép mở rộng linh
                        hoạt trong tương lai đòi hỏi sự cân nhắc kỹ lưỡng. Các bảng và mối quan hệ phức tạp giữa sản
                        phẩm, đơn hàng, và khách hàng cần được thiết kế tối ưu cho cả hiệu suất và tính nhất quán.
                    </p>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-4 rounded-lg shadow-sm border-l-4 border-orange-500 hover:shadow-md transition-shadow col-span-1 md:col-span-2">
                    <h3 className="text-lg font-semibold mb-2 text-orange-800">Phối hợp làm việc nhóm hiệu quả</h3>
                    <p className="text-gray-700">
                        Dự án được phát triển bởi một nhóm 4 thành viên, đòi hỏi sự phối hợp chặt chẽ và quy trình làm
                        việc hiệu quả. Việc quản lý phiên bản code, giải quyết xung đột merge, chia sẻ kiến thức và đảm
                        bảo chất lượng code nhất quán giữa các thành viên là những thách thức quan trọng trong quá trình
                        phát triển.
                    </p>
                </div>
            </div>

            <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-500 mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Cách tiếp cận giải quyết vấn đề</h3>
                <p className="text-gray-700 mb-3">
                    Để vượt qua các thách thức trên, đội dự án đã áp dụng một số phương pháp và quy trình hiệu quả:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                    <li>Thiết lập quy trình phát triển Agile với Sprint 2 tuần và daily standup meetings</li>
                    <li>Thực hiện code review và trao đổi đối với cho các tính năng phức tạp</li>
                    <li>Xây dựng các component và custom hooks tái sử dụng để tối ưu hóa workflow</li>
                    <li>Tạo API documentation chi tiết và rõ ràng cho việc tích hợp frontend-backend</li>
                    <li>
                        Áp dụng mô hình mock API cho các phần chưa hoàn thiện nhằm tăng tốc độ phát triển song song giữa
                        frontend và backend
                    </li>
                </ul>
            </div>
        </>
    ),
    learnings: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Bài học kinh nghiệm</h2>
            <p className="mb-4">
                Dự án quản lý bán hàng tại quầy của chúng tôi, dựa trên ý tưởng và mô hình của Sapo POS, đã mang lại
                nhiều bài học quý giá cho cả đội phát triển:
            </p>

            <div className="space-y-6 mb-6">
                <div className="flex items-start">
                    <div className="bg-blue-100 text-blue-800 p-2 rounded-full mr-4 mt-1">1</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Quy trình phát triển phần mềm chuyên nghiệp</h3>
                        <p className="text-gray-700">
                            Việc áp dụng quy trình Agile với các sprint ngắn, daily standup và retrospectives đã giúp
                            đội dự án duy trì tiến độ, phát hiện vấn đề sớm và liên tục cải tiến quy trình làm việc.
                            Kinh nghiệm này đặc biệt quan trọng trong việc quản lý dự án phức tạp và đa thành phần.
                        </p>
                    </div>
                </div>

                <div className="flex items-start">
                    <div className="bg-green-100 text-green-800 p-2 rounded-full mr-4 mt-1">2</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Kỹ năng làm việc nhóm</h3>
                        <p className="text-gray-700">
                            Dự án đã rèn luyện kỹ năng giao tiếp, phối hợp và giải quyết xung đột trong nhóm. Việc phân
                            chia công việc hợp lý, chia sẻ kiến thức và hỗ trợ lẫn nhau đã góp phần quan trọng vào thành
                            công chung của dự án.
                        </p>
                    </div>
                </div>

                <div className="flex items-start">
                    <div className="bg-red-100 text-red-800 p-2 rounded-full mr-4 mt-1">3</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Kiến thức chuyên sâu về công nghệ</h3>
                        <p className="text-gray-700">
                            Việc làm việc với stack công nghệ hiện đại từ ReactJS, Redux Toolkit đến Spring Boot, JWT đã
                            giúp nâng cao kiến thức kỹ thuật. Đặc biệt, kinh nghiệm xử lý các vấn đề phức tạp như state
                            management, authentication, và performance optimization là những bài học quý giá.
                        </p>
                    </div>
                </div>

                <div className="flex items-start">
                    <div className="bg-yellow-100 text-yellow-800 p-2 rounded-full mr-4 mt-1">4</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Kỹ năng giải quyết vấn đề</h3>
                        <p className="text-gray-700">
                            Đối mặt với các thách thức kỹ thuật và nghiệp vụ phức tạp đã phát triển tư duy giải quyết
                            vấn đề. Khả năng phân tích vấn đề, tìm kiếm giải pháp, và đánh giá các phương án khác nhau
                            đã được nâng cao thông qua dự án này.
                        </p>
                    </div>
                </div>

                <div className="flex items-start">
                    <div className="bg-purple-100 text-purple-800 p-2 rounded-full mr-4 mt-1">5</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Quản lý thời gian</h3>
                        <p className="text-gray-700">
                            Hoàn thành một dự án lớn trong thời gian 1 tháng đòi hỏi kỹ năng quản lý thời gian hiệu quả.
                            Việc ưu tiên các tính năng, phân bổ thời gian hợp lý, và đảm bảo tiến độ đã giúp dự án hoàn
                            thành đúng hạn.
                        </p>
                    </div>
                </div>

                <div className="flex items-start">
                    <div className="bg-indigo-100 text-indigo-800 p-2 rounded-full mr-4 mt-1">6</div>
                    <div>
                        <h3 className="text-lg font-semibold mb-2">Hiểu biết sâu về nghiệp vụ bán lẻ</h3>
                        <p className="text-gray-700">
                            Dự án đã cung cấp cái nhìn sâu sắc về các quy trình nghiệp vụ trong lĩnh vực bán lẻ. Hiểu
                            biết về quy trình bán hàng, quản lý kho, chăm sóc khách hàng, và báo cáo kinh doanh là nền
                            tảng quan trọng cho việc phát triển các ứng dụng doanh nghiệp trong tương lai.
                        </p>
                    </div>
                </div>
            </div>
        </>
    ),
    conclusion: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết luận</h2>
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg shadow-md mb-6 border-l-4 border-blue-500">
                <p className="mb-4 text-gray-800 leading-relaxed">
                    Dự án của chúng tôi là một hệ thống <strong>Quản lý bán hàng tại quầy</strong>, được thiết kế để hỗ trợ các cửa hàng
                    bán lẻ vừa và nhỏ số hóa quy trình kinh doanh và tối ưu hóa hiệu suất vận hành. Hệ thống tập trung
                    vào việc mang lại giải pháp toàn diện với trải nghiệm người dùng thân thiện và các tính năng đáp ứng
                    tốt nhu cầu cơ bản của doanh nghiệp.
                </p>
                <p className="mb-4 text-gray-800 leading-relaxed">
                    Quá trình phát triển dự án giúp chúng tôi tích lũy nhiều kinh nghiệm thực tế trong phát triển phần
                    mềm chuyên nghiệp, đồng thời cải thiện kỹ năng làm việc nhóm, giải quyết vấn đề và tiếp cận các công
                    nghệ hiện đại. Đây là một cột mốc quan trọng trong hành trình học hỏi và phát triển chuyên môn của
                    nhóm.
                </p>
                <p className="mb-4 text-gray-800 leading-relaxed">
                    Tóm lại, hệ thống <strong>Quản lý bán hàng tại quầy</strong> không chỉ thể hiện sự nỗ lực và sáng tạo của nhóm mà còn
                    mang lại giá trị thực tiễn cao, đồng thời tạo nền tảng vững chắc cho các dự án và thử thách trong
                    tương lai.
                </p>
            </div>

            <div className="flex flex-col items-center mt-8">
                <div className="bg-white p-5 rounded-xl shadow-lg w-full max-w-3xl mb-4">
                    <h3 className="text-xl font-semibold text-center text-blue-700 mb-3">
                        Từ ý tưởng đến sản phẩm hoàn chỉnh: Hành trình phát triển hệ thống quản lý bán hàng tại quầy
                    </h3>
                    <div className="flex justify-center">
                        <img
                            src="/assets/images/projects/sapo-pos/intro.jpg"
                            alt="Hệ thống quản lý bán hàng tại quầy"
                            className="rounded-lg shadow-md w-full max-w-2xl hover:shadow-xl transition-shadow duration-300"
                        />
                    </div>
                    <p className="text-sm text-center text-gray-600 italic mt-3">
                        Hệ thống quản lý bán hàng tại quầy - Một giải pháp được phát triển trong thời gian thực tập tại
                        Sapo
                    </p>
                </div>
            </div>
        </>
    ),
    responsibilities: [
        'Xây dựng base dự án và phát triển frontend với ReactJS, Redux Toolkit và Material UI',
        'Xây dựng backend API với Spring Boot và Spring Security',
        'Tham gia thiết kế cơ sở dữ liệu và quan hệ giữa các thực thể',
        'Tham gia triển khai hệ thống xác thực và phân quyền với JWT',
        'Phát triển các tính năng quản lý bán hàng tại quầy và khách hàng',
        'Tối ưu hiệu suất và trải nghiệm người dùng',
        'Triển khai tích hợp với Cloudinary để quản lý hình ảnh',
        'Xây dựng các báo cáo thống kê với biểu đồ trực quan',
    ],
    teamSize: 4,
    duration: '1 tháng',
    role: 'Full Stack Developer',
};
